export const INN_ORG_MAX_LENGTH = 10;
export const KPP_ORG_MAX_LENGTH = 9;
export const OGRN_ORG_MAX_LENGTH = 13;

export const RolesEnums = {
  BUYER: 'buyer',
  SELLER: 'seller',
  REPRESENTATIVE: 'representative',
  // Заявитель
  DECLARANT: 'declarant',
  // Застройщик
  DEVELOPER: 'developer',
  // Дольщик
  SHAREHOLDER: 'shareholder',
  // Арендатор
  RENTER: 'renter',
  // Арендодатель
  LANDLORD: 'landlord',
  // Залогодержатель
  PLEDGEE: 'pledgee',
  // Залогодатель
  PLEDGER: 'pledger',
  // Залогодатель
  OWNER: 'owner',
  // Внешний подписант
  EXT_SIGNER: 'extsigner',
  // Новый собственник
  NEW_OWNER: 'newOwner',
  // Старый собственник
  OLD_OWNER: 'oldOwner'
}

export const SubjectType = {
  PERSON: 'person',
  ORGANIZATION: 'organization'
}

export const SubjectTypeTitle = {
  PERSON: 'Физическое лицо',
  ORGANIZATION: 'Юридическое лицо'
}

export const RegistrationTypes = {
  // Регистрация ДКП
  REGISTRATION_DKP: 'registrationDKP',
  // Регистрация ДДУ
  REGISTRATION_SHARE: 'registrationShare',
  // Регистрация обременения
  MORTGAGE_REGISTRATION: 'mortgageRegistration',
  // Регистрация ипотеки в силу договора (залога)
  REG_MORTGAGE_AGREEMENT: 'regMortgageAgreement',
  // Снятие обременения
  REPAYMENT_MORTGAGE_REG_RECORD: 'repaymentMortgageRegRecord',
  // Погасить запись об ипотеке в силу договора
  PAYOFF_MORTGAGE_RECORD: 'payoffMortgageRecord',
  // Дополнительное заявление
  ADDITIONAL_STATEMENT: 'additionalStatement',
  // Регистрация соглашение об уступке требований по договору
  REG_ASSIGNMENT_AGREEMENT: 'regAssignmentAgreement',
  // Внесение изменений в запись ЕГРН (Право, Обременение, Ограничение)
  MAKING_CHANGES_STATEMENT: 'makingChangesStatement',
  // Внесение сведений в ЕГРН по инициативе заинтересованного лица
  ENTERING_INFORMATION_TO_EGRN: 'enteringInformationToEGRN',
  // Регистрация договора аренды
  REG_RENT_AGREEMENT: 'rentRegAgreement',
  // Постановка на ГКУ без регистрации права
  REG_GKU_WO_RIGHT: 'regGKUwoRight',
  // Постановка на ГКУ и регистрация прав
  REG_GKU_W_RIGHT: 'regGKUwRight',
  // Расторжение ДКП
  TERMINATION_DKP: 'terminationDKP',
  // Учет изменений без регистрации права
  CHANGE_SPECIFICATION_WO_RIGHT: 'changeSpecificationWORight',
  //  Регистрация права на долю в общедомовом имуществе
  REG_SHARE_COMMON_PROPERTY: 'regShareCommonProperty',
  //  Регистрация ранее возникшего (до 31.01.1998) права
  REG_PREV_RIGHT_1998: 'regPrevRight1998',
  //  Регистрация права
  REG_RIGHT: 'regRight',
  //  Снятие с кадастрового учета объекта, права на который зарегистрированы в ЕГРН
  PROPERTY_DEREGISTRATION : 'propertyDeregistration',
  // Прекращение права собственности
  TERMINATION_OF_OWNERSHIP_RIGHTS: 'terminationOfOwnershipRights'
}

// Типы заявлений
export const DealStatementTypes = {
  ADDING_DOC_TO_REG: 'addingDocumentsToApplication',
  RETURN_WO_REG:  'returnWithoutRegistration',
  SUSPEND_REG:  'suspendRegistrationSixMonth',
  RESUME_STATEMENT:  'resumeStatement',
  MORTGAGE_REGISTRATION: 'mortgageRegistration'
}

// тип действия по внесению сведений в ЕГРН
export const EnteringInfoActionType = {
  REGISTRY_CHANGE_ACTION: 'registryChangeAction', // Внесение сведений в ЕГРН
  BORDER_ERROR_ACTION: 'borderErrorAction', // Внесение сведений при исправлении технических ошибок в реестре границ
  REGISTRY_ERROR_ACTION: 'registryErrorAction', // Внесение сведений при исправлении технических ошибок в ЕГРН
}

export const InputTypes = {
  CHECKBOX: 'checkbox',
  TEXTAREA: 'checkbox'
}

export const AreaUnit = {
  SQUARE_MILLIMETER: 'squareMillimeter',
  SQUARE_CENTIMETER: 'squareCentimeter',
  SQUARE_DECIMETER: 'squareDecimeter',
  SQUARE_METER: 'squareMeter',
  HECTARE: 'hectare',
  SQUARE_KILOMETER: 'squareKilometer',
  THOUSAND_SQUARE_METERS: 'thousandSquareMeters',
  ARE: 'are'
}

export const SignProviderEnums = {
  SIGNME: 'signme',
  MYDSS: 'mydss'
}